/**
 * Which front end runs on this device: the v2 calendar app (opt-in while it
 * is being built) or the Racked-era one. `?ui=v2` / `?ui=v1` in the URL
 * switches and is remembered.
 */
const UI_KEY = "wreps:ui";

export type UiVersion = "v1" | "v2";

export function chooseUi(): UiVersion {
  const url = new URL(location.href);
  const asked = url.searchParams.get("ui");
  if (asked === "v1" || asked === "v2") {
    try {
      localStorage.setItem(UI_KEY, asked);
    } catch {}
    url.searchParams.delete("ui");
    history.replaceState(history.state, "", url);
  }
  try {
    return localStorage.getItem(UI_KEY) === "v2" ? "v2" : "v1";
  } catch {
    return "v1";
  }
}

/** Switch this device to the other front end and restart. */
export function switchUi(to: UiVersion): void {
  try {
    localStorage.setItem(UI_KEY, to);
  } catch {}
  location.reload();
}
